import { createStyles, makeStyles } from '@material-ui/styles';
import palette from 'theme/palette';

const style = () =>
  createStyles({
    root: {
      position: 'absolute',
      top: '0',
      left: '250px',
      right: '0',
      minHeight: '100svh',
      zIndex: 10,
      background: palette.background.default,
      '@media (max-width: 768px)': {
        left: '0'
      }
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      background: palette.background.lightblue,
      borderRadius: '0 0 50px 50px',
      padding: '20px 30px 30px 30px',
      minHeight: '200px',
      color: palette.text.white,
      '@media (max-width: 425px)': {
        borderRadius: '0 0 25px 25px',
        padding: '15px 20px 20px 20px'
      }
    },
    headerTop: {
      display: 'flex',
      marginLeft: '45%',
      justifyContent: 'space-between',
      '& p': {
        display: 'flex',
        alignItems: 'center',
        background: palette.background.paper,
        borderRadius: palette.borderRadius.default,
        color: palette.text.darker,
        fontWeight: 600,
        fontSize: '1.1rem',
        padding: '0 8px'
      },
      '@media (max-width: 768px)': {
        marginLeft: '0'
      }
    },
    headerBottom: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      '& > h1': {
        fontSize: '2rem',
        textAlign: 'left',
        textShadow: palette.shadows.textShadow,
        '@media (max-width: 425px)': {
          fontSize: '1.5rem',
          marginTop: '20px'
        }
      },
      '& > div': {
        display: 'flex',
        gap: '10px',
        background: palette.background.paper,
        borderRadius: palette.borderRadius.default,
        padding: '2px 3px 2px 7px',
        maxWidth: 'max-content',
        '@media (max-width: 550px)': {
          flexDirection: 'column',
          gap: '0'
        }
      }
    },
    content: {
      padding: '10px 30px 100px 30px',
      '@media (max-width: 425px)': {
        padding: '0 15px 100px 15px'
      }
    },
    colContainer: {
      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        marginBottom: '20px'
      }
    },
    lotsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
      '& > p:last-of-type': {
        padding: '5px 10px',
        background: palette.background.underBox,
        borderRadius: palette.borderRadius.default,
        fontSize: '1.2rem',
        color: palette.text.primary
      }
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
